// extracted by mini-css-extract-plugin
export default {"DownSection":"DownSection_DownSection__XS66c"};